export const takingNextLevelTextContent = {
  headingText: "Taking Crash Games to the Next Level",
  paraText: "Rich set of features, mechanics that take gamification, multiplayer and loyalty to the next level.",
  btnText: "Contact Us",
  imageSrc: "/assets/stock-img/taking_next_level_img.webp",
};
